import React, { useState, useEffect } from "react";
import { useSnackbar } from 'notistack';
import { globalGetService, globalDeleteService, globalExportService } from '../../../globalServices';
import { checkApiStatus, checkPermission } from '../../utils_v2';
import { downloadFileType, numberWithCommas } from '../../../utils'
import { Pagination, FilterComponent, STableLoader, ExportMenu, PageLoader, DeletePopUp, EmptyCollection } from '../../shared_elements';
import { Table, TableBody, Paper, Grid, Button, Tabs, Tab, TableHead, TableRow, TableCell, TableSortLabel, Tooltip } from '@material-ui/core';
import { trackActivity } from '../../../utils/mixpanel';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import AddIcon from '@material-ui/icons/Add';
import VisibilityIcon from '@material-ui/icons/Visibility';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import { nonTitledAssemblyFilters, nonTitledAssemblyObj } from "../../fleet";
import NonTitledAssemblyAttachment from "../../fleet/components/NonTitledAssemblyAttachment";
import AddEditNonTitledAssembly from "../../fleet/components/AddEditNonTitledAssembly";
import { TechSpecsNav } from "../../elements";
import { AssetInfo } from "../components";
import useAssetInfo from '../hooks/useAssetInfo';
import moment from "moment";
import { backendDateFormat } from "../../../constants";
const NonTitledAssembliesHd = ({ sortInfo, createSortHandler }) => {
    return (
        <TableHead>
            <TableRow>
                <TableCell align="left" style={{ position: 'sticky', left: 0, backgroundColor: '#B5BEDB', zIndex: 10, }}>Action(s)</TableCell>
                <TableCell>
                    <TableSortLabel
                        active={sortInfo.sort === 'description' ? true : false}
                        direction={sortInfo.sort === 'description' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('description')}
                    >
                        Description
                    </TableSortLabel>
                </TableCell>
                <TableCell>
                    <TableSortLabel
                        active={sortInfo.sort === 'serial_number' ? true : false}
                        direction={sortInfo.sort === 'serial_number' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('serial_number')}
                    >
                        Serial Number
                    </TableSortLabel>
                </TableCell>
                <TableCell>
                    <TableSortLabel
                        active={sortInfo.sort === 'part_number' ? true : false}
                        direction={sortInfo.sort === 'part_number' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('part_number')}
                    >
                        Part Number
                    </TableSortLabel>
                </TableCell>
                <TableCell>
                    <TableSortLabel
                        active={sortInfo.sort === 'owner' ? true : false}
                        direction={sortInfo.sort === 'owner' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('owner')}
                    >
                        Owner
                    </TableSortLabel>
                </TableCell>
                <TableCell>
                    <TableSortLabel
                        active={sortInfo.sort === 'location' ? true : false}
                        direction={sortInfo.sort === 'location' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('location')}
                    >
                        Location
                    </TableSortLabel>
                </TableCell>
                {/* <TableCell>
                    <TableSortLabel
                        active={sortInfo.sort === 'linked_asset' ? true : false}
                        direction={sortInfo.sort === 'linked_asset' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('linked_asset')}
                    >
                        Linked Asset
                    </TableSortLabel>
                </TableCell> */}
                <TableCell>
                    <TableSortLabel
                        active={sortInfo.sort === 'status' ? true : false}
                        direction={sortInfo.sort === 'status' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('status')}
                    >
                        Status
                    </TableSortLabel>
                </TableCell>
                <TableCell>TSN</TableCell>
                <TableCell>CSN</TableCell>
                <TableCell>TSLSV</TableCell>
                <TableCell>CSLSV</TableCell>
                <TableCell>LLP Limiter</TableCell>
                <TableCell>TSO</TableCell>
                <TableCell>CSO</TableCell>
            </TableRow>
        </TableHead>
    )
}
const NonTitledAssembliesList = ({ item, onView, onEdit, onDelete, onOpenAttachments }) => {
    return (
        <TableRow>
            <TableCell align='left' style={{ position: 'sticky', left: 0, backgroundColor: 'inherit', zIndex: 1, }}>
                <div style={{ minWidth: '140px' }}>
                    <ul className='list-inline flex-centered' style={{ float: 'left' }}>
                        {checkPermission('technical_specs', 'non_titled_assembly', 'U') ?
                        <li style={{ cursor: 'pointer' }} onClick={onEdit} className='list-inline-item'>
                            <Tooltip title='Edit'><EditIcon color='primary' fontSize='small' /></Tooltip>
                        </li>:null
                        }
                        {checkPermission('technical_specs', 'non_titled_assembly', 'D') ?
                        <li style={{ cursor: 'pointer' }} onClick={onDelete} className='list-inline-item'>
                            <Tooltip title='Delete'><DeleteOutlineIcon color='secondary' fontSize='small' /></Tooltip>
                        </li>:null
                         }
                        <li style={{ cursor: 'pointer' }} className='list-inline-item' onClick={onView}>
                            <Tooltip title='View'><VisibilityIcon fontSize='small' color='primary' /></Tooltip>
                        </li>
                        {item?.attachments?.length ?
                            <li style={{ cursor: 'pointer' }} onClick={onOpenAttachments} className='list-inline-item'>
                                <span className='flex-centered'>
                                   <Tooltip title='Attachments'><AttachFileIcon color='primary' fontSize='small' /></Tooltip>
                                    <span>({item.attachments.length})</span>
                                </span>
                            </li> : null
                        }
                    </ul>
                </div>
            </TableCell>
            <TableCell><div style={{ width: '300px' }}>{item?.description || '--'}</div></TableCell>
            <TableCell><div style={{ width: '200px' }}>{item.serial_number}</div></TableCell>
            <TableCell><div style={{ width: '200px' }}>{item?.part_number || '--'}</div></TableCell>
            <TableCell><div style={{ width: '200px' }}>{item?.owner || '--'}</div></TableCell>
            <TableCell><div style={{ width: '200px' }}>{item?.location || '--'}</div></TableCell>
            {/* <TableCell><div style={{ width: '150px' }}>{item?.linked_msn? 'MSN '+ item?.linked_msn?.msn : '--'}</div></TableCell> */}
            <TableCell><div style={{ width: '100px' }}>{item?.status || '--'}</div></TableCell>
            <TableCell><div style={{ width: '120px' }}>{numberWithCommas(item?.tsn)}</div></TableCell>
            <TableCell><div style={{ width: '120px' }}>{numberWithCommas(item?.csn)}</div></TableCell>
            <TableCell><div style={{ width: '120px' }}>{numberWithCommas(item?.tslsv)}</div></TableCell>
            <TableCell><div style={{ width: '120px' }}>{numberWithCommas(item?.cslsv)}</div></TableCell>
            <TableCell><div style={{ width: '120px' }}>{numberWithCommas(item?.llp_limiter)}</div></TableCell>
            <TableCell><div style={{ width: '120px' }}>{numberWithCommas(item?.tso)}</div></TableCell>
            <TableCell><div style={{ width: '120px' }}>{numberWithCommas(item?.cso)}</div></TableCell>
        </TableRow>
    )
}
const NonTitledAssembly = ({params}) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [filter, setFilter] = useState({});
    const { assetInfoData, assetSkeletonLoader, refreshAssetInfo } = useAssetInfo(params.type, params.aircraft_slug);
    const [nonTitledAssemblies, setNonTitledAssemblies] = useState({ list: [], pagination: { page: 1, per_page: 20, total: 100 } });
    const [addEditNonTitledAssemblies, setAddEditNonTitledAssemblies] = useState({ modal: false, mode: '', data: null });
    const [nonTitledAssembliesAttachments, setNonTitledAssembliesAttachments] = useState({ modal: false, data: null })
    const [deleteNonTitledAssemblies, setDeleteNonTitledAssemblies] = useState({ modal: false, data: null });
    useEffect(() => {
        trackActivity('Console Management', { page_title: 'Non Titled Assemblies List', event_type: 'Page Visited', event_desc: 'Visited Non Titled Assemblies List' });
    }, [])
    useEffect(() => {
        if (assetInfoData?.id) {
            getNonTitledAssemblies({ ...filter, per_page: 20 }, 'skeletonLoader');
        }
    }, [assetInfoData])
    const getNonTitledAssemblies = (query = {}, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
        globalGetService(`console/non-titled-assembly/?linked_msn=${assetInfoData?.id}`, query)
            .then(response => {
                if (checkApiStatus(response)) {
                    setNonTitledAssemblies(response.data.data);
                    delete query.page
                    delete query.per_page
                    delete query.sort
                    delete query.sort_by
                    setFilter(query)
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
            })
    }
    const exportNonTitledAssemblies = (extension) => {
        setLoading(true);
        globalExportService(`console/non-titled-assembly/export/?linked_msn=${assetInfoData?.id}`, { download: extension, ...filter })
            .then(response => {
                setLoading(false);
                downloadFileType(response, `Non_Titled_Assembly_${moment().format(backendDateFormat)}`, extension)
                trackActivity('Console Management', { page_title: 'Export Non Titled Assemblies', event_type: 'Item Exported', event_desc: `Exported Non Titled Assemblies from List`, file_extension: extension });
            });
    }
    const onDeleteNonTitledAssemblies = () => {
        globalDeleteService(`console/non-titled-assembly/${deleteNonTitledAssemblies.data.id}/`)
            .then(response => {
                if (checkApiStatus(response)) {
                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                    setDeleteNonTitledAssemblies({ modal: false, data: null });
                    getNonTitledAssemblies({ ...filter, per_page: nonTitledAssemblies?.pagination?.per_page || 20 }, 'skeletonLoader');
                    trackActivity('Console Management', { page_title: 'Delete Non Titled Assembly', event_type: 'Item Deleted', event_desc: `Deleted Non Titled Assembly from List`, delete_id: deleteNonTitledAssemblies?.data?.id });
                }
            })
    }
    const onAttachmentDelete = (uuid) => {
        setNonTitledAssembliesAttachments({
            ...nonTitledAssembliesAttachments, data: {
                ...nonTitledAssembliesAttachments.data,
                attachments: nonTitledAssembliesAttachments.data.attachments.filter(item => item.uuid !== uuid)
            }
        });
        if (addEditNonTitledAssemblies.modal) {
            setAddEditNonTitledAssemblies({
                ...addEditNonTitledAssemblies,
                data: {
                    ...addEditNonTitledAssemblies.data,
                    attachments: addEditNonTitledAssemblies.data.attachments.filter(item => item.uuid !== uuid)
                }
            })
        }
        getNonTitledAssemblies({ ...filter, per_page: nonTitledAssemblies?.pagination?.per_page || 20 }, 'pageLoader');
    }
    const createSortHandler = (key) => {
        let sortQuery = { sort: key };
        if (sortInfo.sort === key) {
            sortQuery = { ...sortQuery, sort_by: sortInfo.sort_by === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort_by: 'asc' }
        }
        setSortInfo(sortQuery)
        getNonTitledAssemblies({ ...filter, ...sortQuery, page: 1, per_page: nonTitledAssemblies?.pagination?.per_page || 20 }, 'pageLoader');
    }
    const filterOptions = Object.fromEntries( Object.entries(nonTitledAssemblyFilters).filter( ([key]) => key !== 'linked_msn' ) );
    return (
        <section className="asset-tech-specs">
            <AssetInfo assetInfoData={assetInfoData} skeletonLoader={assetSkeletonLoader} getResponseBack={refreshAssetInfo} />
            <Paper className="tech-specs-card" style={{ minHeight: `${window.innerHeight - 162}px` }}>
                <TechSpecsNav />
                <div className="tech-specs-content" >                
                    {skeletonLoader||assetSkeletonLoader ? <STableLoader count={10} /> :
                    <div style={{ padding: '10px' }}>
                        <Paper square style={{ padding: '4px 8px' }}>
                            <Grid container spacing={1} alignItems='center'>
                                <Grid item md={9}>
                                    <FilterComponent
                                        filter={filter}
                                        filterMenu={filterOptions}
                                        getResponseBack={(applyFilter) => getNonTitledAssemblies({ ...applyFilter, page: 1, per_page: nonTitledAssemblies?.pagination?.per_page || 20 }, 'pageLoader')}
                                    />
                                </Grid>
                                <Grid item md={3}>
                                    <ul className='list-inline' style={{ float: 'right' }}>   
                                        {nonTitledAssemblies?.list?.length && checkPermission('technical_specs', 'non_titled_assembly', 'EXP')  ?
                                            <li className='list-inline-item'>
                                                <ExportMenu exportReportFn={(file) => exportNonTitledAssemblies(file.extension)} files={[{ title: 'EXCEL', extension: 'xlsx' }]} />
                                            </li> : null
                                        }
                                        { checkPermission('technical_specs', 'non_titled_assembly', 'C') ?
                                        <>
                                            <li className='list-inline-item'>
                                                <Button onClick={() => setAddEditNonTitledAssemblies({ modal: true, mode: 'add', data: { ...nonTitledAssemblyObj, linked_msn: assetInfoData?.id  } })} color='primary' size="small" variant="contained"><AddIcon style={{ fontSize: '1.15rem' }} />Add</Button>
                                            </li>
                                        </>:null}
                                    </ul>
                                </Grid>
                            </Grid>
                        </Paper>
                            <Paper square>
                              <div style={{ height: window.innerHeight - 290 + 'px', overflow: "auto" }}>
                                <Table className='mui-table-format' stickyHeader>
                                    <NonTitledAssembliesHd
                                        sortInfo={sortInfo}
                                        createSortHandler={createSortHandler}
                                    />
                                    <TableBody>
                                        {nonTitledAssemblies.list.map((item, index) =>
                                            <NonTitledAssembliesList
                                                item={item}
                                                onView={() => setAddEditNonTitledAssemblies({ modal: true, mode: 'view', data: item })}
                                                onEdit={() => setAddEditNonTitledAssemblies({ modal: true, mode: 'edit', data: item })}
                                                onDelete={() => setDeleteNonTitledAssemblies({ modal: true, data: item })}
                                                onOpenAttachments={() => setNonTitledAssembliesAttachments({ modal: true, data: item })}
                                            />
                                        )}
                                    </TableBody>
                                </Table>
                                 {!nonTitledAssemblies?.list?.length ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
                                </div>
                            </Paper>
                            {nonTitledAssemblies?.list?.length ?
                                <Paper square>
                                    <Pagination
                                        pagination={nonTitledAssemblies.pagination}
                                        onChangePage={(event, newPage) => getNonTitledAssemblies({ ...filter, page: newPage + 1, per_page: nonTitledAssemblies?.pagination?.per_page || 20 }, 'pageLoader')}
                                        onChangeRowsPerPage={(event) => getNonTitledAssemblies({ ...filter, page: 1, per_page: event.target.value }, 'pageLoader')}
                                    />
                                </Paper> : null}
                    </div>
                }
            </div>
            </Paper>
            {addEditNonTitledAssemblies.modal ?
                <AddEditNonTitledAssembly
                    basicDetails={true}
                    addEditNonTitledAssemblies={addEditNonTitledAssemblies}
                    toggleModalFn={() => setAddEditNonTitledAssemblies({ modal: false, mode: '', data: null })}
                    getResponseBack={() => getNonTitledAssemblies({ ...filter, per_page: nonTitledAssemblies?.pagination?.per_page || 20 }, 'pageLoader')}
                    onOpenAttachments={() => setNonTitledAssembliesAttachments({ modal: true, data: addEditNonTitledAssemblies.data })}
                /> : null
            }
            {deleteNonTitledAssemblies.modal ?
                <DeletePopUp
                    modal={deleteNonTitledAssemblies.modal}
                    title='Delete Non Titled Assembly'
                    content={`Are you sure, you want to Delete?`}
                    toggleModalFn={() => setDeleteNonTitledAssemblies({ modal: false, data: null })}
                    deleteRecordFn={onDeleteNonTitledAssemblies}
                /> : null
            }
            {nonTitledAssembliesAttachments.modal ?
                <NonTitledAssemblyAttachment
                    nonTitledAssembliesAttachments={nonTitledAssembliesAttachments}
                    getResponseBack={onAttachmentDelete}
                    toggleModalFn={() => { setNonTitledAssembliesAttachments({ modal: false, data: null }); }}
                /> : null
            }
            {isLoading ? <PageLoader /> : null}
        </section>
    )
}
export default NonTitledAssembly;